<template>
  <div class="shelf-status">
    <NavHeaderBar navBarTitle="Product Listing Status" :showSearch="false" />
    <div>
      <div class="info collapse-sub">
        <div class="sub-top">
          <div class="left-title">{{ $t('form.currentProductListingStatus') }}</div>
        </div>
        <div class="sub-bottom">
          <div class="sub-listing-item">{{ $t('form.listing') }} {{ shelfInfo.listing }}</div>
          <div class="sub-listing-item not-listing-item">{{ $t('form.notListing') }} {{ shelfInfo.notListing }}</div>
          <div class="sub-listing-item end-listing-item">{{ $t('form.endOfSales') }} {{ shelfInfo.endSales }}</div>
          <div class="sub-listing-item unknown-listing-item">{{ $t('shared.filter.unknown') }} {{ shelfInfo.unknown }}</div>
        </div>
      </div>
      <div class="info">
        <div class="item-info">
          <div class="item-section custom-section">
            <van-collapse v-for="shelfItem in shelfList" :key="`collapse-${shelfItem.projectId}`" v-model="shelfItem.activeNames">
              <van-collapse-item :name="shelfItem.projectId" >
                <template #title>
                  <div class="list-label square">
                    {{ shelfItem.projectName }}
                  </div>
                </template>
                <van-collapse v-for="proItem in shelfItem.productList" :key="`collapse-${proItem.productId}`" v-model="proItem.activeNames">
                  <van-collapse-item :name="proItem.productId" :disabled="proItem.isShelf !== 1">
                    <template #title>
                      <div class="collapse-title">
                        <span>{{ proItem.productName }} {{ $t('form.listed') }}</span>
                        <span>{{ proItem.isShelf == 0 ? $t('form.notListing') : proItem.isShelf == 1 ? $t('form.listing') : proItem.isShelf == -1 ? $t('form.endOfSales') : $t('shared.filter.unknown') }}</span>
                      </div>
                    </template>
                    <div class="status-info" v-for="logItem in proItem.shelfLogList" :key="logItem.id">
                      <div class="status-item" v-if="logItem.shelfType">{{ logItem.shelfType }}</div>
                      <div>{{ $t('form.lastest') }}: {{ logItem.lastCreateTime }} <span v-if="logItem.lastSaleCount"><span class="num">{{ logItem.lastSaleCount }}</span> {{ $t('form.pcs') }}</span></div>
                    </div>
                  </van-collapse-item>
                </van-collapse>
              </van-collapse-item>
            </van-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { customerShelfGeneralApi, customerShelfInfoApi, sdShelfGeneralApi, sdShelfShelfInfoApi } from '@/api/shared'
export default {
  data () {
    return {
      paramsUrl: {},
      shelfInfo: {},
      shelfList: []
    }
  },
  activated () {
    this.paramsUrl = this.$route.query
    this.getShelfData()
  },
  methods: {
    getShelfData () {
      const generalRequestApi = this.paramsUrl.pageType === 'salesDistribution' ? sdShelfGeneralApi : customerShelfGeneralApi
      generalRequestApi(this.paramsUrl.customerId).then(res => {
        this.shelfInfo = res.data
      })
      const shelfInfoRequestApi = this.paramsUrl.pageType === 'salesDistribution' ? sdShelfShelfInfoApi : customerShelfInfoApi
      shelfInfoRequestApi(this.paramsUrl.customerId).then(res => {
        if (res.data && res.data.length > 0) {
          this.shelfList = res.data.map(item => ({
            ...item,
            activeNames: [item.projectId],
            productList: item.productList.map(proItem => ({
              ...proItem,
              // activeNames: !proItem.shelfLogList ? [] : proItem.shelfLogList.length > 0 ? [proItem.productId] : [],
              activeNames: [],
              shelfLogList: proItem.isShelf === 1 ? proItem.shelfLogList : []
            }))
          }))
        } else {
          this.shelfList = []
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.shelf-status {
  .info {
    margin-bottom: 20px;
    .item-title {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      color: #307bff;
      &::before {
        content: '';
        width: 6px;
        height: 12px;
        margin-right: 3px;
        background-color: #307bff;
      }
    }
    .item-info {
      padding: 0px 10px;
      .item-section {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        border-bottom: 1px solid #e8effc;
        .left {
          width: 148px;
        }
        .right {
          flex: 1;
          text-align: right;
        }
      }
      .custom-section {
        display: block;
        padding: 0;
        .list-label {
          display: flex;
          align-items: center;
          padding-left: 1px;
          margin-top: 10px;
          font-weight: bold;
          &.square {
            font-weight: bold;
            &::before {
              content: '';
              width: 8px;
              height: 8px;
              background-color: #307bff;
              // position: absolute;
              // left: 0;
              // top: 0;
              transform: rotate(45deg);
              margin-right: 5px;
            }
          }
        }
        .collapse-title {
          display: flex;
          justify-content: space-between;
          padding: 5px 0;
          font-size: 12px;
          color: #000;
        }
        .status-info {
          display: flex;
          align-items: center;
          margin-bottom: 5px;
          font-size: 12px;
          &:last-child {
            margin-bottom: 10px;
          }
          .status-item {
            padding: 2px;
            border: 1px solid #307bff;
            color: #307bff;
            margin-right: 5px;
            font-size: 10px;
          }
          .num {
            color: #307bff;
          }
        }
        /deep/.van-collapse {
          border-bottom: 1px solid #e8effc;
          &:last-child {
            border-bottom: none;
          }
          .van-collapse-item {
            border-bottom: 1px solid #e8effc;
            &:last-child {
              border-bottom: none;
            }
          }
          .van-collapse-item__title {
            display: flex;
            align-items: center;
            padding: 2px 0;
          }
          .van-collapse-item__title::after {
            display: none;
          }
          .van-collapse-item--border::after {
            display: none;
          }
          .van-collapse-item__content {
            padding: 0px 0;
            color: #000;
          }
          .custom-collapse {
            .van-collapse-item__content {
              display: none;
            }
          }
          .van-collapse-item__title--disabled {
            .van-icon {
              display: none;
            }
          }
        }
        /deep/.van-hairline--top-bottom::after {
          border: none;
        }
      }
    }
  }
  .collapse-sub {
    padding: 8px 10px;
    margin-bottom: 0px;
    border-bottom: 1px solid #e8effc;
    .sub-top {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      .left-title {
        color: #333;
        font-weight: bold;
        font-size: 14px;
      }
      .to-detail {
        color: #307bff;
        text-decoration: underline;
      }
    }
    .sub-bottom {
      display: flex;
      flex-wrap: wrap;
      .sub-listing-item {
        padding: 3px 5px;
        margin-right: 5px;
        margin-bottom: 3px;
        color: #50ad34;
          background-color: rgba(80, 173, 52, .2);
        border-radius: 5px;
        font-size: 12px;
      }
      .not-listing-item {
        color: #e79d42;
          background-color: rgba(231, 157, 66, .2);
      }
      .end-listing-item {
        color: #C4200B;
          background-color: rgba(196, 32, 11, .2);
      }
      .unknown-listing-item {
        color: #333;
        background-color: rgba(51, 51, 51, .2);
      }
    }
  }
}
</style>
